<template>
  <div>
    <el-form :model="queryForm" :inline="true">
      <el-row>
        <el-col :span="6">
          <el-form-item label="患儿姓名" prop="childName">
            <el-input type="text" v-model="queryForm.childName" size="small" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="费用编号" prop="outlayId">
            <el-input type="text" v-model="queryForm.outlayId" size="small" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <SearchButton @search="searchForm" @reset="resetSearchForm" @expand="e => expand = e">
            <el-button v-if="active == 'todo'" icon="el-icon-plus" type="primary" size="small" @click="addAngleOutlay">分期费用</el-button>
            <span style="width: 175px ; display:inline-block" v-if="active == 'BatchOperation'">
              <el-button   style="float: left" type="primary" size="small" @click="exportExcel">费用导出</el-button>
              <el-upload
                 class="my-upload-demo"
                 :action="action"
                 method="post"
                 :headers="headers"
                 :auto-upload="true"
                 accept=".xlsx,.xls "
                 :on-error="uploadFileError"
                 :on-success="uploadFileSuccess"
                 :show-file-list="false"
                 :file-list="fileList"
                 ref="upload"
                 :limit="1" >
                 <el-button  style="float: left" size="small" type="primary">费用导入</el-button>
              </el-upload>
            </span>
          </SearchButton>
        </el-col>
      </el-row>
      <el-row v-if="expand">
<!--        <el-col :span="6" v-if="!isHospitalRole">-->
<!--          <el-form-item label="救助医院" prop="hospitalId">-->
<!--            <HospitalSelect v-model="queryForm.hospitalId"></HospitalSelect>-->
<!--          </el-form-item>-->
<!--        </el-col>-->
        <el-col :span="6">
          <el-form-item label="申请时间" prop="helpQuota">
            <el-date-picker
              v-model="queryForm.helpTimeRange"
              type="daterange"
              size="small"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="关联协议" prop="outlayId">
            <el-input type="text" v-model="queryForm.protocolId" size="small" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      v-loading="loading"
      :data="tableData"
      style="width: 100%" height='calc(100vh - 285px)' ref="multipleTable"
      :row-key="getRowKeys" @selection-change="handleSelectionChange">
      <el-table-column v-if="active == 'BatchOperation'" label-class-name="table-selection"   type="selection" width="50"  align="center" fixed="left" :reserve-selection="true" />
      <el-table-column key="outlayId" prop="outlayId" label="费用编号" width="150" style="font-size: 14px;">
        <template slot-scope="scope">
          <span class="link" @click="outlayFillIn(scope.row)">{{scope.row.outlayId}}</span>
        </template>
      </el-table-column>
      <el-table-column key="beginTime" v-if="['todo','BatchOperation'].indexOf(active) < 0" prop="beginTime" label="提交时间" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.beginTime ? parseTime(scope.row.beginTime, '{y}-{m}-{d}') : '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column key="childName" prop="childName" label="患儿姓名" width="110">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.childName"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column key="hospitalName" v-if="isHospital==='false'"   width="140"   label="救助医院">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.hospitalName"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column key="beforeDiseasesName" prop="beforeDiseasesName" label="病种" width="180">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.afterDiseasesName || scope.row.beforeDiseasesName"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column key="curStages" prop="curStages" align="center" label="期次" width="60">
        <template slot-scope="scope">
          {{scope.row.curStages}}/{{scope.row.initialProject == 'AY1002' ? '-' : (scope.row.totalStages || '-')}}
        </template>
      </el-table-column>
      <el-table-column key="birthday" prop="birthday" label="出生日期" width="100"></el-table-column>
      <el-table-column key="sex" prop="sex" width="50" label="性别">
        <template slot-scope="scope">
          {{scope.row.sex == 1 ? '男' : scope.row.sex==0 ?'女' : '未知'}}
        </template>
      </el-table-column>
      <el-table-column key="operationAmount" prop="operationAmount" label="治疗总费用" width="110" align="right">
        <template slot-scope="scope">
          {{scope.row.operationAmount == 0 ? parseFloat(0).toFixed(2) : (scope.row.operationAmount ? parseFloat(scope.row.operationAmount).toFixed(2) : '-')}}
        </template>
      </el-table-column>
      <el-table-column key="reimburAmount" prop="reimburAmount" label="医保报销" width="110" align="right">
        <template slot-scope="scope">
          {{scope.row.reimburAmount == 0 ? parseFloat(0).toFixed(2) : (scope.row.reimburAmount ? parseFloat(scope.row.reimburAmount).toFixed(2) : '-')}}
        </template>
      </el-table-column>
      <el-table-column key="selfPayAmount" prop="selfPayAmount" label="自付费用" width="110" align="right">
        <template slot-scope="scope">
          {{scope.row.selfPayAmount == 0 ? parseFloat(0).toFixed(2) : (scope.row.selfPayAmount ? parseFloat(scope.row.selfPayAmount).toFixed(2) : '-')}}
        </template>
      </el-table-column>
      <el-table-column key="helpAmount" prop="helpAmount" width="110" label="救助费用" align="right">
        <template slot-scope="scope">
          {{scope.row.helpAmount == 0 ? parseFloat(0).toFixed(2) : (scope.row.helpAmount ? parseFloat(scope.row.helpAmount).toFixed(2) : '-')}}
        </template>
      </el-table-column>
      <el-table-column key="outlayStatusName" prop="outlayStatusName" label="费用状态"></el-table-column>
      <el-table-column key="protocolId" v-if="active == 'done'" prop="protocolId" label="关联协议" width="170">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.protocolId">{{scope.row.protocolId || '-'}}</TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column key="helpTime" prop="helpTime" label="申请时间" width="110">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.helpTime, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column key="helpApprTime" prop="helpApprTime" label="审核时间" width="110">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.helpApprTime, '{y}-{m}-{d}') }}</span>
        </template>
      </el-table-column>
      <el-table-column key="option" width="110" fixed="right" label="操作" v-if="active == 'todo' || active == 'rollback' || active=='BatchOperation'">
        <template slot-scope="scope">
          <el-button v-if="[0, 2].indexOf(scope.row.outlayStatus) > -1 && scope.row.hospitalIsAuto != 1" plain type="primary" size="mini" @click="outlayFillIn(scope.row)">费用填写</el-button>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>
    <Pageination
      @sizeChange="handleSizeChange"
      @currentChange="handleCurrentChange"
      :currentPage="queryParams.pageNO"
      :total="total">
    </Pageination>
    <el-dialog
      title="治疗费用"
      :loading="dialogLoading"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="closeDialog"
      width="1200px">
        <div v-if="rowData.isSend == 0 && [0, 1, 2].indexOf(rowData.outlayStatus) > -1 && rowData.hospitalIsAuto != 1" style="text-align: right; padding: 0 16px 16px 0; background: white;">
          <el-button v-if="rowData.outlayStatus != 1" :loading="btnLoading" type="primary" icon="el-icon-s-release" size="mini" @click="saveData">保存</el-button>
          <el-button :loading="btnLoading" type="primary" icon="el-icon-success" size="mini" @click="submitData">提交</el-button>
        </div>
        <div v-if="dialogVisible && rowData.outlayStatus == 0" style="padding: 16px;">
          <CureOutlayDetail
            ref="cureOutlay"
            :outlayId="rowData.outlayId"
            :belongProject="rowData.initialProject"
            @close="closeDialog"
            @beforeSave="btnLoading = true"
            @saveComplete="btnLoading = false"
            @success="formSaveSuccess">
          </CureOutlayDetail>
        </div>
        <el-tabs v-if="dialogVisible && rowData.outlayStatus > 0" v-model="dialogActiveName">
          <el-tab-pane label="费用信息" name="outlayInfo">
            <CureOutlayDetail
              ref="cureOutlay"
              :outlayId="rowData.outlayId"
              :belongProject="rowData.initialProject"
              @beforeSave="btnLoading = true"
              @saveComplete="btnLoading = false"
              @close="closeDialog"
              @success="formSaveSuccess">
            </CureOutlayDetail>
          </el-tab-pane>
          <el-tab-pane label="审核记录" name="outlayHistory">
            <OutlayHistory v-if="dialogActiveName == 'outlayHistory'" :outlayId="rowData.outlayId"></OutlayHistory>
          </el-tab-pane>
        </el-tabs>
    </el-dialog>
    <CureAngleChildDialog
      v-if="angleOutlayVisible"
      :visible="angleOutlayVisible"
      @autoAdd="addAutoAngleOutlay"
      @success="addAngleOutlaySuccess"
      @close="angleOutlayVisible = false">
    </CureAngleChildDialog>
    <CureAngleAutoOutlay
      v-if="angleAutoOutlayVisible"
      :visible.sync="angleAutoOutlayVisible"
      :formData="angleAutoOutlayData"
      @success="addAngleAutoOutlaySuccess"
      @close="angleAutoOutlayVisible = false">
    </CureAngleAutoOutlay>
    <div class="dialog_diy">
    <el-dialog title="提示" :visible.sync="showErrorIcon" width="45%" :close-on-click-modal="false" class="dialogClass">
     <div style="width: 630px ; margin: auto">
       <div>
         <img src="/static/err-icon.png" alt=""  style="width: 20px;height: 20px; float: left"/>
       </div>
       <div style="width: 580px;height: 90px;float: left;margin-left: 15px">
         <span style="color: #333333 ; font-size: 17px; font-weight:bold;">部分费用未提交成功转入待处理状态，请手动填写或重新填写表格数据再导入</span><br/>
         <span style="color: #666666;font-size: 14px;line-height:30px;">共{{resultMap.AllConut}}条记录，提交{{resultMap.submitCount}}条，保存{{resultMap.saveCount}}条，重复导入{{resultMap.submitBigData}}条（费用已上报）</span><br/>
         <span style="color: #666666;font-size: 14px;line-height:15px;">费用提交失败原因:</span>
       </div>
     </div>
      <div class="dialog-body">
        <el-table ref="ridioTable"
                  :data="resultData"
                  tooltip-effect="dark"
                  height="250"
                  style="width: 620px ; margin: auto">
          <el-table-column type="index" width="50" label="序号">
          </el-table-column>
          <el-table-column label="患儿姓名" width="120">
            <template slot-scope="scope">
              <TableCellWordBreak :content="scope.row.childName"></TableCellWordBreak>
            </template>
          </el-table-column>
          <el-table-column label="错误原因" width="450">
            <template slot-scope="scope">
              <TableCellWordBreak :content="scope.row.excePtion"></TableCellWordBreak>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer" >
        <el-button type="primary" size="small" @click="closeShowErrorIcon()" >关 闭</el-button>
      </div>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getOutlayDataListByCond ,
  exportExcelOutlayList,
  outlay_import_excel
} from "@/util/api.js";
import HospitalSelect from "@/components/business/HospitalSelect";
import DiseaseCascader from "@/components/business/DiseaseCascader";
import SearchButton from "@/components/business/SearchButton";
import Pageination from "@/components/business/Pageination";
import TableCellWordBreak from "@/components/business/TableCellWordBreak"

import CureOutlayDetail from "./CureOutlayDetail";
import CureAngleChildDialog from './CureAngleChildDialog.vue'
import CureAngleAutoOutlay from './CureAngleAutoOutlay.vue'
import OutlayHistory from '../view/OutlayHistory'

// const headers = {
//   'Authorization': window.localStorage.getItem('token')
// };


export default {
  components: {
    HospitalSelect,
    TableCellWordBreak,
    DiseaseCascader,
    CureOutlayDetail,
    CureAngleChildDialog,
    CureAngleAutoOutlay,
    OutlayHistory,
    SearchButton,
    Pageination
  },
  props: {
    active: {
      type: String,
      default: 'todo'
    },
  },
  data() {
    let isHospitalRole = this.isHospital();
    return {
      action: outlay_import_excel,
      headers: {},
      isHospitalRole: isHospitalRole,
      loading: false,
      btnLoading: false,
      expand: false,
      queryForm: {},
      queryParams: {
        pageNO: 1,
        pageSize: 10,
        searchCond: {}
      },
      isHospital:'false',
      defaultSearchCond: {},
      dialogVisible: false,
      dialogLoading: false,
      angleOutlayVisible: false,
      angleAutoOutlayVisible: false,
      angleAutoOutlayData: {},
      dialogActiveName: 'outlayInfo',
      tableData: [],
      rowData: {},
      total: 0,
      exportExcelList:[],//所选择的费用
      fileList:[],
      resultMap:{},
      showErrorIcon:false,
      resultData:{},
    };
  },
  watch: {
    active (val) {
      this.queryParams.pageNO = 1;
      this.initDefaultSearchCond();
      this.loadData()
    },
    $route(to,from){
      this.loadData();
    }
  },
  mounted () {
   this.headers= {
      'Authorization': window.localStorage.getItem('token')
    };
    this.isHospital = window.localStorage.getItem("hospAccount")
    this.queryParams.pageNO = 1;
    this.initDefaultSearchCond();
    this.loadData();
  },
  methods: {
    initDefaultSearchCond () {
      // 费用类型：1=治疗费用，2=检查费用
      this.defaultSearchCond.outlayType = 1;
      this.defaultSearchCond.isTimeout = 0;
      if (this.active == 'todo') {
        this.defaultSearchCond.outlayStatus = 0;
        this.defaultSearchCond.belongProjectBath = null;
      } else if (this.active == 'done') {
        this.defaultSearchCond.outlayStatus = 1;
        this.defaultSearchCond.belongProjectBath = null;
      } else if (this.active == 'rollback') {
        this.defaultSearchCond.outlayStatus = 2;
        this.defaultSearchCond.belongProjectBath = null;
      } else if (this.active == 'timeout') {
        this.defaultSearchCond.outlayStatus = null;
        this.defaultSearchCond.belongProjectBath = null;
        this.defaultSearchCond.isTimeout = 1;
      }else if (this.active == 'BatchOperation'){
        this.defaultSearchCond.outlayStatus = 0;
        this.defaultSearchCond.belongProjectBath = "'AY1002'";
      }
    },
    loadData () {
      this.loading = true
      if (this.queryForm.helpTimeRange && this.queryForm.helpTimeRange.length > 1) {
        this.queryForm.helpTimeBegin = this.queryForm.helpTimeRange[0];
        this.queryForm.helpTimeEnd = this.queryForm.helpTimeRange[1];
      }
      this.queryParams.searchCond = Object.assign({}, this.defaultSearchCond, this.queryForm);
      this.queryParams.searchCond.applyType = 1;
      getOutlayDataListByCond(this.queryParams).then(res => {
        this.tableData = res.responseData.modelData;
        this.total = res.responseData.total;
        this.loading = false
      })
    },
    addAutoAngleOutlay (row) {
      this.angleOutlayVisible = false;
      this.angleAutoOutlayVisible = true;
      this.angleAutoOutlayData = row;
      console.log(this.angleAutoOutlayData)
    },
    searchForm () {
      this.queryParams.pageNO = 1;
      this.loadData();
    },
    resetSearchForm () {
      this.queryParams.pageNO = 1;
      this.queryForm = {}
      this.loadData(),
        //重置复选框
      this.toggleSelection()
    },
    outlayFillIn(row) {
      this.rowData = row
      this.dialogVisible = true
      this.dialogLoading = true
      this.dialogActiveName = 'outlayInfo';
    },
    closeDialog () {
      this.dialogVisible = false
      this.btnLoading = false;
      this.rowData = {}
    },
    formSaveSuccess () {
      this.dialogLoading = false;
      this.btnLoading = false;
      this.closeDialog();
      this.loadData();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.queryParams.pageNO = val
      this.loadData()
    },
    openScreenFun() {
      this.openScreen1 = !this.openScreen1;
    },
    saveData () {
      this.$refs.cureOutlay.saveData();
    },
    submitData () {
      this.$refs.cureOutlay.submitData();
    },
    addAngleOutlay () {
      this.angleOutlayVisible = true;
    },
    addAngleOutlaySuccess (outlay) {
      this.angleOutlayVisible = false;
      this.loadData();
      this.outlayFillIn(outlay);
    },
    addAngleAutoOutlaySuccess () {
      this.angleAutoOutlayVisible = false;
      this.loadData();
    },
    //获取每一行数据
    getRowKeys (row) {
      return row.outlayId;
    },
    //取消复选框
    toggleSelection(){
      this.$refs.multipleTable.clearSelection();
    },

    handleSelectionChange(val) {
      console.log("选择",val)
      this.exportExcelList=val;
    },

    //导出费用
    exportExcel(){
      if(this.exportExcelList!=undefined && this.exportExcelList.length==0){
        this.$message.error('请选择患儿')
      }else {
        var currentDate = "";
        var yy = new Date().getFullYear();
        var mm = new Date().getMonth()+1;
        var dd = new Date().getDate();
        currentDate = yy.toString()+(mm.toString().length<2 ? "0"+mm.toString() : mm.toString())+ (dd.toString().length<2 ? "0"+dd.toString() : dd.toString());
        exportExcelOutlayList(this.exportExcelList).then(data => {
          let url = window.URL.createObjectURL(new Blob([data]));
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', '患儿费用列表'+currentDate+'.xls');
          document.body.appendChild(link);
          link.click();
        }).catch()

      }
    },


    handlePreview(file){
      console.log(file);
    },

    /**
     * 费用导入失败
     */

    uploadFileError(err, file, fileList) {
      console.log(err)
      this.$message.error('费用导入失败')
    },

    /**
     * 费用导入
     */
    uploadFileSuccess(response, file, fileList) {
      if(response.msgCode==200){
        this.$message.success("导入成功,并已全部提交")
        this.$refs.upload.clearFiles();
        this.initDefaultSearchCond();
        this.loadData();
      }else if(response.msgCode==300){
        this.$refs.upload.clearFiles();
        this.resultMap=JSON.parse(response.msg);
        this.resultData=this.resultMap.resultExcelsList;
        this.showErrorIcon=true;
        this.initDefaultSearchCond();
        this.loadData();
      }else if(response.msgCode==500){
        this.$message.error("服务端出错")
        this.$refs.upload.clearFiles();
      }
    },

    closeShowErrorIcon(){
      this.showErrorIcon=false;
      this.$refs.upload.clearFiles();
      this.initDefaultSearchCond();
      this.loadData();
    }

  },
};
</script>

<style lang="scss" scoped>
@import 'src/common/form.scss';
@import "src/common/dialog.scss";

.my-upload-demo /deep/ .el-upload--text{
  margin-left: 15px;
}

//.el-table /deep/.table-selection .cell{
//  padding-left: 14.2px;
//}

.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 30px;
}
//.dialogClass /deep/ el-dialog /deep/ .el-dialog__body {
// background-color: #2FCC69;
//}


.dialog_diy{
  /deep/ .el-dialog__wrapper {
    .el-dialog {
      border-radius: 5px;
      .el-dialog__body{
        background-color: #FFFFFF !important;
      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/pages/outlay/cure/CureOutlayTable.vue